import {useFormikContext} from 'formik';
import {isEqual} from 'lodash';
import {useEffect} from 'react';
import {useAppDispatch} from 'store/customer';
import {addChange, removeChange, Type} from 'store/customer/appSlice';

export const DimensionUpdateHandler = ({
    productId,
}: {
    productId: number;
}): JSX.Element => {
    const dispatch = useAppDispatch();
    const {initialValues, values} = useFormikContext();

    useEffect(() => {
        if (!isEqual(initialValues, values)) {
            dispatch(addChange({id: productId, type: Type.PRODUCT_DIMENSION}));
        } else {
            dispatch(
                removeChange({id: productId, type: Type.PRODUCT_DIMENSION})
            );
        }
    }, [productId, initialValues, values]);

    return null;
};
